<div v-if="enableSteckdosen" class="matrix_optionsTable matrix_table" id="steckdosen_container">
  <div class="matrix_tableHeader">{{ $t("Sockets") }}</div>
  <div id="steckdosen_popup" class="sidebar_popup">
    <div id="steckdosen_toolbar">
      <div id="steckdosen_toolbar">
        <div
          v-for="socket in getSockets"
          class="steckdosen_item steckdosen_item_draggable"
          :data-info="JSON.stringify(socket)"
        >
          <img v-bind:src="socket.image_url" />
          <span class="opacity"></span>
          <span class="select_dosen">+</span>
        </div>
      </div>
      <div style="clear: both;"></div>
    </div>
    <ul class="dimensions-list" v-show="total">
      <li
        v-for="(dosen, index) in getSteckdosen.dosens"
        class="newdosen_item"
        :id="'steckdosen-item-' + index"
      >
        <span class="number">{{index + 1}}</span>
        <div
          class="newdosen-icon dosen"
          v-bind:style="{ 'background-image': 'url('+dosen.imageSrc+')' }"
        ></div>
        <div class="posxy">
          <div class="pos_input">
            <label :for="'dosenX-' + index">{{$t('X:')}}</label>
            <input
              v-model="dosen.left"
              :id="'dosenX-' + index"
              type="number"
              min="0"
              step="0.1"
                v-on:keydown.enter="onEnter"
              :value.number="parseFloat(dosen.left).toFixed(2)"
              class="steckdosen_input"
            />
            <span class="cm">{{$t('cm')}}</span>
          </div>
          <div class="pos_input">
            <label :for="'dosenY-' + index">{{$t('Y:')}}</label>
            <input
              v-model="dosen.bottom"
              :id="'dosenY-' + index"
              type="number"
              min="0"
                v-on:keydown.enter="onEnter"
              step="0.1"
              :value.number="parseFloat(dosen.bottom).toFixed(2)"
              class="steckdosen_input"
            />
            <span class="cm">{{$t('cm')}}</span>
          </div>
        </div>
        <div @click="removeSteckDosen(index)" class="delete-dosen">          
          <appAwesomeIcon icon="trash-alt" useClass="fa fa-trash-o" />
        </div>
      </li>
    </ul>
  </div>
</div>
